const ElemState = {"Normal":1, "Hover":2, "P1Block":3, "P2Block": 4}
Object.freeze(ElemState)
const ElemType = {"HEDGE": 1, "VEDGE": 2, "SLOT": 3, "CROSS": 4}
Object.freeze(ElemType)

function isEmptyState(state) {
    return state == ElemState.Normal || state == ElemState.Hover;
}

class GridElement {
    // constructor
    constructor(idname, etype) {
        this.id = idname;
        this.state = ElemState.Normal;
        this.type = etype;
    }

    getEdge() {
        if (this.type !== ElemType.HEDGE && this.type != ElemType.VEDGE) {
            return null;
        }
        let vertexs = this.id.split('-');
        vertexs[0] = parseInt(vertexs[0]);
        vertexs[1] = parseInt(vertexs[1]);
        return vertexs;
    }
}
class Board {
    // constructor

    constructor(width, height, walls) {
        this.width = width;
        this.height = height;
        // one the top
        this.player1Pos = [0, Math.trunc(this.width/2)];
        this.player2Pos = [this.height-1, Math.trunc(this.width/2)];
        //=> [0, 1, ..., this.width-1]
        this.player2Targets = [...Array(this.width).keys()];
        this.player1Targets = [...Array(this.width).keys()].map(x => (this.height-1)*this.width + x);
        // one the bottom
        this.player1LegalMoves = [];
        this.player2LegalMoves = [];
        this.player1RemainWalls = walls;
        this.player2RemainWalls = walls;

        this.winner = 0;

        // 1 for player 1
        // 2 for player 2
        this.toPlay = 1;

        this.board = new Array(height);
        for (var i = 0; i < height; i++) {
            this.board[i] = new Array(width);
        }
        // edges
        this.adjMatrix = new Array(height);
        for (i = 0; i < height*width; i++) {
            this.adjMatrix[i] = new Array(height*width);
        }
        for (i = 0; i < height*width; i++) {
            for (var j = 0; j < height*width; j++) {
                this.adjMatrix[i][j] = 0;
            }
        }

        this.gridIDS = [];
        for (var row = 0; row < height; row++) {
            // vertical
            var verticalGids = [];
            for (var col = 0; col < width; col++) {
                let currID = this.getID(row, col);
                let rightID = this.getID(row, col+1);
                if (col != width-1) {
                    this.adjMatrix[currID][rightID] = 1;
                    this.adjMatrix[rightID][currID] = 1;
                }
                let slotElem = new GridElement(currID.toString(), ElemType.SLOT);
                verticalGids.push(slotElem)
                if (col != width-1) {
                    let edgeElem = new GridElement(currID+'-'+rightID, ElemType.VEDGE);
                    verticalGids.push(edgeElem)
                }
            }
            this.gridIDS.push(verticalGids)
            if (row == height-1) {
                continue;
            }
            var horizGids = [];
            for (col = 0; col < width; col++) {
                let currID = this.getID(row, col);
                let downID = this.getID(row+1, col);
                this.adjMatrix[currID][downID] = 1;
                this.adjMatrix[downID][currID] = 1; 
                let elemElem = new GridElement(currID+'-'+downID, ElemType.HEDGE);
                horizGids.push(elemElem);
                if (col != width-1) {
                    let corssElem = new GridElement('', ElemType.CROSS);
                    horizGids.push(corssElem);
                }
            }
            this.gridIDS.push(horizGids) 
        }
    }

    getID(row, col) {
        return row * this.width + col
    }

    canPutOnGridElement(iidx, jidx) {
        let gridElem = this.gridIDS[iidx][jidx];
        if (gridElem.type !== ElemType.VEDGE && gridElem.type !== ElemType.HEDGE) {
            return false
        }
        if (!isEmptyState(gridElem.state)) {
            return false
        }
        // right side and down side
        if (gridElem.type == ElemType.HEDGE) {
            let col = Math.trunc(jidx/2);
            if (col == this.width-1) {
                return false
            }
            // if (this.gridIDS[iidx][jidx+1].state != ElemState.Normal || this.gridIDS[iidx][jidx+2].state != ElemState.Normal) {
            //     return false
            // }
            if (!isEmptyState(this.gridIDS[iidx][jidx+1].state) || !isEmptyState(this.gridIDS[iidx][jidx+2].state)) {
                return false
            }
        }
        if (gridElem.type == ElemType.VEDGE) {
            let row = Math.trunc(iidx/2);
            if (row == this.height-1) {
                return false
            }
            // if (this.gridIDS[iidx+1][jidx].state != ElemState.Normal || this.gridIDS[iidx+2][jidx].state != ElemState.Normal) {
            //     return false
            // }
            if (!isEmptyState(this.gridIDS[iidx+1][jidx].state) || !isEmptyState(this.gridIDS[iidx+2][jidx].state)) {
                return false
            }
        }
        return true
    }

    setNext3Edge(iidx, jidx, state) {
        this.gridIDS[iidx][jidx].state = state; 
        if (this.gridIDS[iidx][jidx].type == ElemType.HEDGE) {
            this.gridIDS[iidx][jidx+1].state = state;
            this.gridIDS[iidx][jidx+2].state = state;
        }
        if (this.gridIDS[iidx][jidx].type == ElemType.VEDGE) {
            this.gridIDS[iidx+1][jidx].state = state;
            this.gridIDS[iidx+2][jidx].state = state;
        }
    }

    putOnWall(iidx, jidx) {
        this.clearLegalMoves();
        
        let edge0 = this.gridIDS[iidx][jidx].getEdge();
        this.setBlockEdge(edge0[0], edge0[1]);
        if (this.gridIDS[iidx][jidx].type == ElemType.HEDGE) {
            let edge1 = this.gridIDS[iidx][jidx+2].getEdge();
            this.setBlockEdge(edge1[0], edge1[1]);
        }
        if (this.gridIDS[iidx][jidx].type == ElemType.VEDGE) {
            let edge1 = this.gridIDS[iidx+2][jidx].getEdge();
            this.setBlockEdge(edge1[0], edge1[1]);
        }

        //=> [0, 1, ..., this.width-1]
        // let firstRow = [...Array(this.width).keys()];
        // let lastRow = [...Array(this.width).keys()].map(x => (this.height-1)*this.width + x);
        // canReachTarget
        if (!this.canReachTarget(this.player1Pos, this.player2Pos, new Set(), this.player1Targets) || 
            !this.canReachTarget(this.player2Pos, this.player1Pos, new Set(), this.player2Targets)) {
                // in this case can some player can not reach target
                this.resetBlockEdge(edge0[0], edge0[1]);
                if (this.gridIDS[iidx][jidx].type == ElemType.HEDGE) {
                    let edge1 = this.gridIDS[iidx][jidx+2].getEdge();
                    this.resetBlockEdge(edge1[0], edge1[1]);
                }
                if (this.gridIDS[iidx][jidx].type == ElemType.VEDGE) {
                    let edge1 = this.gridIDS[iidx+2][jidx].getEdge();
                    this.resetBlockEdge(edge1[0], edge1[1]);
                }
                return false;
        } else {
            this.setNext3Edge(iidx, jidx, ElemState.P1Block);
            if (this.toPlay == 1) {
                this.player1RemainWalls -= 1;
            } else if (this.toPlay == 2) {
                this.player2RemainWalls -= 1;
            }
            this.toggleToPlay();
            return true;
        }
    }

    setBlockEdge(v0, v1) {
        this.adjMatrix[v0][v1] = 0;
        this.adjMatrix[v1][v0] = 0;
    }

    resetBlockEdge(v0, v1) {
        this.adjMatrix[v0][v1] = 1;
        this.adjMatrix[v1][v0] = 1;
    }

    canReachTarget(pos, rivalPos, visited, targets) {
        let x = pos[0];
        let y = pos[1];
        visited.add(this.getID(x, y));
        if (targets.includes(this.getID(x, y))) {
            return true
        }
        let neighbors = this.getLegalMoves(pos, rivalPos);
        for (var neig of neighbors) {
            let neigID = this.getID(neig[0], neig[1]);
            if (visited.has(neigID)) {
                continue;
            }
            let res = this.canReachTarget(neig, rivalPos, visited, targets);
            if (res) {
                return true;
            }
        }
        return false
    }

    isPlayer1InGrid(iidx, jidx) {
        if (this.gridIDS[iidx][jidx].type !== ElemType.SLOT) {
            return false;
        }
        let row = Math.trunc(iidx/2);
        let col = Math.trunc(jidx/2);
        return this.player1Pos[0] == row && this.player1Pos[1] == col;
    }

    isPlayer2InGrid(iidx, jidx) {
        if (this.gridIDS[iidx][jidx].type !== ElemType.SLOT) {
            return false;
        }
        let row = Math.trunc(iidx/2);
        let col = Math.trunc(jidx/2);
        return this.player2Pos[0] == row && this.player2Pos[1] == col;
    }
    
    updatePlayer1LegalMoves() {
        this.clearLegalMoves();
        let moves = this.getLegalMoves(this.player1Pos, this.player2Pos);
        for (var move of moves) {
            let x = move[0];
            let y = move[1];
            this.player1LegalMoves.push(this.getID(x, y));
        }
    }

    updatePlayer2LegalMoves() {
        this.clearLegalMoves();
        let moves = this.getLegalMoves(this.player2Pos, this.player1Pos);
        for (var move of moves) {
            let x = move[0];
            let y = move[1];
            this.player2LegalMoves.push(this.getID(x, y));
        }
    }

    getLegalMoves(selfPos, rivalPos) {
        let deltaPairs = [[0, 1], [0, -1], [-1, 0] ,[1, 0]];
        let res = [];
        let selfX = selfPos[0];
        let selfY = selfPos[1];
        let selfID = this.getID(selfX, selfY);
        let rivalX = rivalPos[0];
        let rivalY = rivalPos[1];
        let rivalID = this.getID(rivalX, rivalY);
        for (var idx = 0; idx < deltaPairs.length; idx++) {
            let pair = deltaPairs[idx];
            let dx = pair[0];
            let dy = pair[1];
            let x = selfX + dx;
            let y = selfY + dy;
            let newID = this.getID(x, y);
            if (x < 0 || x >= this.height || y < 0 || y >= this.width) {
                continue;
            }
            if (this.adjMatrix[selfID][newID] === 0) {
                continue
            } 
            if (newID !== rivalID) {
                res.push([x, y]);
                continue
            }
            // newID === rivalID
            // x o  -> x o o
            let doubleDX = dx*2;
            let doubleDY = dy*2;
            let douX = selfX + doubleDX;
            let douY = selfY + doubleDY;
            let douNewID = this.getID(douX, douY);
            if (this.isRowColValid(douX, douY) && this.adjMatrix[rivalID][douNewID] !== 0) {
                res.push([douX, douY]);
                continue;
            } 
            // check
            //   -   
            // T o T
            //   x
            let ldx = dx === 0 ? 1 : dx;
            let ldy = dy === 0 ? 1 : dy;
            let lx = selfX + ldx;
            let ly = selfY + ldy;
            if (this.isRowColValid(lx, ly) && this.adjMatrix[rivalID][this.getID(lx, ly)] !== 0) {
                res.push([lx, ly]);
            }
            let rdx = dx === 0 ? -1 : dx;
            let rdy = dy === 0 ? -1 : dy;
            let rx = selfX + rdx;
            let ry = selfY + rdy;
            if (this.isRowColValid(rx, ry) && this.adjMatrix[rivalID][this.getID(rx, ry)] !== 0) {
                res.push([rx, ry]);
            }
        }
        return res;
    }

    isRowColValid(row, col) {
        if (row < 0 || row >= this.height || col < 0 || col >= this.width) {
            return false;
        }
        return true;
    }

    clearLegalMoves() {
        this.player1LegalMoves = [];
        this.player2LegalMoves = [];
    }

    // return 0 not legal
    // return 1 for player 1
    // return 2 for player 2
    isShowingLealMoves(iidx, jidx) {
        if (this.gridIDS[iidx][jidx].type !== ElemType.SLOT) {
            return false;
        }
        let row = Math.trunc(iidx/2);
        let col = Math.trunc(jidx/2);
        let id = this.getID(row, col);
        if (this.player1LegalMoves.includes(id)) {
            return 1;
        }
        if (this.player2LegalMoves.includes(id)) {
            return 2;
        }
        return 0;
    }

    movePlayer(row, col, player) {
        if (player == 1) {
            this.player1Pos = [row, col];
            this.clearLegalMoves();
            if (this.player1Targets.includes(this.getID(row, col))) {
                this.winner = 1;
            }
            this.toggleToPlay();
        } else if (player == 2) {
            this.player2Pos = [row, col];
            this.clearLegalMoves();
            if (this.player2Targets.includes(this.getID(row, col))) {
                this.winner = 2;
            }
            this.toggleToPlay();
        }
    }

    isPlayer1ToPlay() {
        return this.toPlay == 1;
    }

    toggleToPlay() {
        if (this.toPlay == 1) {
            this.toPlay = 2;
        } else {
            this.toPlay = 1;
        }
    }
}

export {
    Board, ElemState, ElemType
}